import { animate, style, transition, trigger } from "@angular/animations";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Gallery, GalleryItem, YoutubeItem } from "@ngx-gallery/core";
import { Lightbox } from "@ngx-gallery/lightbox";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import * as $ from "jquery";
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { ResponsiveSlideHelper } from "../../core/_helpers";
import { ImageService } from "../../core/services/image.service";
import { DemoDialogComponent } from "../../shared/components";
import { I18nService } from "../../shared/services";
import { MetaTagService } from "../../shared/services/meta-tag.service";
import { PowerBiService } from "../../shared/services/powerbi.service";
import { AuthenticationService } from "../auth/authentication.service";
import { HomeVideo, SlideVideo } from "../models/home-video.model";
import { DemoDialogService } from "../services/dialog";
import { HomeVideosService } from "../services/home-videos.service";
import { SiilaTranslationService } from "../services/siila-translation.service";
import { SpotService } from "../services/spot.service";

interface SlickResponsiveSettings {
  slidesToShow: number;
  slidesToScroll: number;
  infinite?: boolean;
}

interface SlickResponsiveBreakpoint {
  breakpoint: number;
  settings: SlickResponsiveSettings;
}

interface SlickSlideConfig {
  arrows: boolean;
  mobileFirst: boolean;
  responsive: SlickResponsiveBreakpoint[];
}

interface SpotSearchUrlResponse {
  url: string;
}

@Component({
  selector: "home-view",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  animations: [
    trigger("slideAnimation", [
      transition(":enter", [style({ opacity: 0 }), animate(250)]),
      transition(":leave", [style({ opacity: 1 }), animate(250)])
    ])
  ]
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild("slickCarousel", { static: true })
  carousel: SlickCarouselComponent;

  browserLang: string = "en";
  color = "#04354f";
  portraitMode: boolean = false;
  videoItems: GalleryItem[];
  homeVideos: HomeVideo[];
  slideVideos: SlideVideo[];
  brakpointSubscription: Subscription;
  translateSubscription: Subscription;
  isExpanded: boolean = false;
  currentCode: string;
  slidesConfig: typeof ResponsiveSlideHelper.DEFAULT_SLIDE_CONFIG =
    ResponsiveSlideHelper.DEFAULT_SLIDE_CONFIG;
  SaleLease = "lease";
  propertyType = "office";
  property = "";
  playVideo = 0;
  urlVideo =
    "https://fast.wistia.net/embed/iframe/m9jprhk22h?videoFoam=true&autoplay=0";

  slideConfig: SlickSlideConfig = {
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
          //dots: true
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
          //dots: true
        }
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
          //dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  isMobile = false;
  routerSub: Subscription;
  latamCountry = "latamMx";
  siilaDemoAlt: string;

  constructor(
    public sanitize: DomSanitizer,
    public breakpointObserver: BreakpointObserver,
    public auth: AuthenticationService,
    private _translate: TranslateService,
    private gallery: Gallery,
    private _lightbox: Lightbox,
    private siilaTranslationService: SiilaTranslationService,
    private videosService: HomeVideosService,
    private imgService: ImageService,
    private metaTagSrv: MetaTagService,
    private powerBiService: PowerBiService,
    private imageService: ImageService,
    private demoDialog: DemoDialogService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private i18n: I18nService,
    private spotService: SpotService,
    private router: Router
  ) {
    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    this.currentCode = environment.platformId;
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  get spotLogo() {
    return this.currentCode == "mx"
      ? "assets/img/home-list/logo-mx.png"
      : "assets/img/home-list/logo.png";
  }

  ngOnInit() {
    this.routerSub = this.route.paramMap.subscribe((params: ParamMap) => {
      this.metaTagSrv.setHomePageMetaTags();
    });
    this.getCarouselVideos();
    this.brakpointSubscription = this.subscribeBreakpoint();
    this.translateSubscription = this.subscribeToLangChange();
    this.powerBiService.prefetchReports();
    this.siilaDemoAlt = this.siilaTranslationService.getImgSEOTranslation(
      "siilaDemoAlt"
    );
  }

  ngOnDestroy() {
    this.brakpointSubscription.unsubscribe();
    this.translateSubscription.unsubscribe();
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  subscribeToLangChange() {
    return this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (this.browserLang != event.lang) {
        this.browserLang = event.lang;
        this.loadGallery(true);
      }
    });
  }

  subscribeBreakpoint() {
    return this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.portraitMode = result.matches;
      });
  }

  getCarouselVideos() {
    this.videosService.getHomeVideos().subscribe(
      (response: HomeVideo[]) => {
        this.homeVideos = response;
        this.loadGallery();
      },
      error => {
        var message = this.siilaTranslationService.getTranslationFromJSONFiles(
          "videos.errorMessage"
        );
        console.error(`${message}: ${error.error.message}`);
      }
    );
  }

  public sanitizeURL(URL: string) {
    return this.sanitize.bypassSecurityTrustResourceUrl(URL);
  }

  openCard(index: number): void {
    this._lightbox.open(index, "homeGallery");
  }

  loadGallery(reload?: boolean) {
    this.slideVideos = [];
    let parsedVideos = [];

    this.homeVideos.forEach(item => {
      const imgId = this.siilaTranslationService.getTranslation(
        item.thumbnailId
      );
      const thumb = this.imgService.largeThumbnail(imgId);

      this.slideVideos.push({ thumb });
      parsedVideos.push(
        new YoutubeItem({
          src: this.siilaTranslationService.getTranslation(item.videoId),
          thumb: thumb
        })
      );
    });

    if (reload) {
      this.carousel.unslick();
    }

    this.gallery.ref("homeGallery").load(parsedVideos);
  }

  nextSlide(carousel: SlickCarouselComponent) {
    if (!carousel) {
      return;
    }
    carousel.slickNext();
  }

  prevSlide(carousel: SlickCarouselComponent) {
    if (!carousel) {
      return;
    }
    carousel.slickPrev();
  }

  playButton(isExpanded: boolean) {
    this.isExpanded = !isExpanded;
  }

  getMediumImg(id: number) {
    return this.imageService.mediumThumbnail(id);
  }

  showCoworkingOption() {
    return this.isForBR() && this.SaleLease === "lease";
  }

  isForBR() {
    return this.currentCode === "br" || this.latamCountry === "latamBr";
  }

  openSearch() {
    let baseUrl: string;
    let legacyUrl: string;

    if (
      (this.currentCode === "latam" || this.currentCode === "co") &&
      this.latamCountry === "latamMx"
    ) {
      baseUrl = environment.spotURLMx;
    } else {
      baseUrl = environment.spotURL;
    }

    let req: any = {};
    let spotType = this.SaleLease == "lease" ? "L" : "S";
    let propertyTypeIds;
    const isForCoworking = this.propertyType == "coworking";
    if (isForCoworking) {
      propertyTypeIds = 2001;
      spotType = "C";
    } else {
      propertyTypeIds =
        this.propertyType == "office"
          ? 2001
          : this.propertyType == "warehouse"
          ? 1001
          : this.propertyType == "coworking"
          ? 2001
          : -1;
    }

    req.listingLeaseOrSale = [...spotType];
    req.buildingTypes = [propertyTypeIds];
    let customLang = this.i18n.getCurrentLanguage();
    if (customLang === "en-mx") {
      customLang = "en";
    }

    this.spotService.getUrlFromListingsSearchDto(this.latamCountry, req).then(
      (response: SpotSearchUrlResponse) => {
        if (response && response.url) {
          const localizedUrls: Record<string, string> = JSON.parse(
            response.url
          );
          const newUrl = `${baseUrl}${this.getSpotSearchURL()}${
            localizedUrls[customLang]
          }/${customLang}`;
          window.open(newUrl, "_blank");
        } else {
        }
      },
      (error: unknown) => {
        console.error("Error fetching URL from search DTO:", error);
      }
    );
  }

  getSpotSearchURL() {
    let baseUrl: string;
    const lang = this.i18n.getCurrentLanguage();
    if (
      (this.currentCode === "latam" || this.currentCode === "co") &&
      this.latamCountry === "latamMx"
    ) {
      baseUrl = lang === "en" ? "search" : "resultado";
    } else {
      baseUrl = lang === "en" ? "search" : "resultado";
    }
    return `/${baseUrl}`;
  }

  playPauseVideo() {
    /* if (this.browserLang === "en") {
      if (this.playVideo == 0) {
        this.playVideo = 1;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/m9jprhk22h?videoFoam=true&autoplay=${this.playVideo}`;
      } else {
        this.playVideo = 0;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/m9jprhk22h?videoFoam=true&autoplay=${this.playVideo}`;
      }
    }

    if (this.browserLang === "es") {
      if (this.playVideo == 0) {
        this.playVideo = 1;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/3orowoyw8h?videoFoam=true&autoplay=${this.playVideo}`;
      } else {
        this.playVideo = 0;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/3orowoyw8h?videoFoam=true&autoplay=${this.playVideo}`;
      }
    }

    if (this.browserLang === "pt") {
      if (this.playVideo == 0) {
        this.playVideo = 1;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/d5ne2f8jzh?videoFoam=true&autoplay=${this.playVideo}`;
      } else {
        this.playVideo = 0;
        this.urlVideo = `https://fast.wistia.net/embed/iframe/d5ne2f8jzh?videoFoam=true&autoplay=${this.playVideo}`;
      }
    } */
    $(".popupVideoButton")[0].click();
  }

  public getCompanyLogoImg(id: number) {
    return id ? this.getMediumImg(id) : "../../../assets/no-company-logo.png";
  }

  public openDemoDialog() {
    this.demoDialog.open(DemoDialogComponent);
  }
}

export interface Article {
  date: string;
  headline: string;
  id: string;
}
